export const token = localStorage.getItem('token');

export const userId = localStorage.getItem('user_id');

export const email = localStorage.getItem('user');

export const department = localStorage.getItem('department');

export const getCookie = (name: string): string | undefined => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop()?.split(';').shift();
  return undefined;
};

export const xsrfToken = getCookie('XSRF-TOKEN');

// Static object for backwards compatibility (deprecated - use getAuthHeaderDynamic instead)
export const getAuthHeader = {
  'x-idToken': token || '',
  'x-user_id': userId || '',
  user: email || '',
  'x-department': department || '',
  'x-xsrf-token': xsrfToken || '',
};

// Dynamic function that reads fresh values from localStorage
export const getAuthHeaderDynamic = () => ({
  'x-idToken': localStorage.getItem('token') || '',
  'x-user_id': localStorage.getItem('user_id') || '',
  user: localStorage.getItem('user') || '',
  'x-department': localStorage.getItem('department') || '',
  'x-xsrf-token': getCookie('XSRF-TOKEN') || '',
});
